<template>
  <div>
    <Form ref="tableForm" :model="form" label-position="left">
      <Row>
        <Col span="16">
          <Row>
            <Col span="8" v-if="show.school_name">
              <FormItem prop="school_cname" class="item">
                <Input v-model="form.school_cname" :placeholder="$t('school_record.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.contact_name">
              <FormItem prop="contact_name" class="item">
                <Input v-model="form.contact_name" :placeholder="$t('contact_name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.teacher_name">
              <FormItem prop="teacher_name" class="item">
                <Input v-model="form.teacher_name" :placeholder="$t('teacher_record.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.send_user">
              <FormItem prop="send_user" class="item">
                <Input v-model="form.send_user" :placeholder="$t('cms_email.send_user')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.email_title">
              <FormItem prop="title" class="item">
                <Input v-model="form.title" :placeholder="$t('cms_email.title')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.user_name">
              <FormItem prop="title" class="item">
                <Input v-model="form.cname" :placeholder="$t('user')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.blog_title">
              <FormItem prop="title" class="item">
                <Input v-model="form.title" :placeholder="$t('title')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.email_name">
              <FormItem prop="mailname" class="item">
                <Input v-model="form.mailname" :placeholder="$t('cms_email.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.mail_name">
              <FormItem prop="mailname" class="item">
                <Input v-model="form.cname" :placeholder="$t('mail_user_name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.role_name">
              <FormItem prop="cname" class="item">
                <Input v-model="form.cname" :placeholder="$t('Role.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" prop="cname" v-if="show.baseMtag_name">
              <FormItem class="item">
                <Input v-model="form.cname" :placeholder="$t('Tags.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.baseMtagItem_name">
              <FormItem class="item" prop="cname">
                <Input v-model="form.cname" :placeholder="$t('Tags.names')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.infoPush_name">
              <FormItem class="item" prop="cname">
                <Input v-model="form.cname" :placeholder="$t('infoPush.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.renewal_name">
              <FormItem class="item" prop="cname">
                <Input v-model="form.cname" :placeholder="$t('renewal.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.ad_name">
              <FormItem class="item" prop="cname">
                <Input v-model="form.cname" :placeholder="$t('Ad.name_home')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.blog_ad_name">
              <FormItem class="item" prop="cname">
                <Input v-model="form.cname" :placeholder="$t('cent.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.tech_ad_name">
              <FormItem class="item" prop="cname">
                <Input v-model="form.cname" :placeholder="$t('techCentName')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.wellness_name">
              <FormItem class="item" prop="cname">
                <Input v-model="form.cname" :placeholder="$t('wellness.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.wealth_name">
              <FormItem class="item" prop="cname">
                <Input v-model="form.cname" :placeholder="$t('wealth.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.travel_name">
              <FormItem class="item" prop="cname">
                <Input v-model="form.cname" :placeholder="$t('travel.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.adImfo_name">
              <FormItem class="item" prop="cname">
                <Input v-model="form.cname" :placeholder="$t('Ad.name_history')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.faculty_name">
              <FormItem prop="faculty_name" class="item">
                <Input v-model="form.faculty_name" :placeholder="$t('faculty.name')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.contact_phone">
              <FormItem prop="contact_phone" class="item">
                <Input v-model="form.contact_phone" :placeholder="$t('contact_mobile')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.email">
              <FormItem prop="email" class="item">
                <Input v-model="form.email" :placeholder="$t('email')" class="input" />
              </FormItem>
            </Col>
            <Col span="8" v-if="show.status">
              <FormItem prop="status" class="item">
                <Select v-model="form.status" :placeholder="$t('school_record.status')" class="input">
                  <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8" v-if="show.jobType">
              <FormItem prop="status" class="item">
                <Select v-model="form.status" :placeholder="$t('job.type')" class="input">
                  <Option v-for="(item,index) in typeList" :value="item.key" :key="index">{{ item.value }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8" v-if="show.jobStatus">
              <FormItem prop="status" class="item">
                <Select v-model="form.status" :placeholder="$t('release_status')" class="input">
                  <Option v-for="(item,index) in SchoolStatusList" :value="item.key" :key="index">{{ item.value }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8" v-if="show.wellness_type">
              <FormItem prop="status" class="item">
                <Select v-model="form.health_type" :placeholder="$t('type')" class="input">
                  <Option v-for="(item,index) in typeList" :value="item.key" :key="index">{{ item.value }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8" v-if="show.schoolStatus">
              <FormItem prop="status" class="item">
                <Select v-model="form.status" :placeholder="$t('school_record.status')" class="input">
                  <Option v-for="(item,index) in SchoolStatusList" :value="item.value" :key="index">{{ item.text }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8" v-if="show.renewal_time">
              <FormItem prop="renewal_time" class="item">
                <DatePicker v-model="form.renewal_time" type="daterange" :placeholder="$t('school_record.renewal_time')" class="input" @on-change="onDate" />
              </FormItem>
            </Col>

            <Col span="8" v-if="show.expireStatus">
              <FormItem prop="status" class="item">
                <Select v-model="form.status" :placeholder="$t('payment')" class="input">
                  <Option v-for="(item,index) in SchoolStatusList" :value="item.renewal_id" :key="index">{{ item.renewal_cname }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
        </Col>
        <Col span="7" offset="1" class="but">
          <Button type="primary" @click="handleSubmit">{{ $t("table.search") }}</Button>
          <Button @click="handleReset" style="margin-left: 15px">{{ $t("table.reset") }}</Button>
        </Col>
      </Row>
    </Form>

    <!-- DatePicker有bug 会出现自动填写密码遮挡选择日期  -->
    <Input class="hide_input" />
  </div>
</template>

<script>
import { isEmpty } from "../utils/base";

export default {
  props: {
    show: Object
  },
  watch: {
    show: {
      handler (newValue, oldValue) {
        this.info()
      },
      deep: true
    }
  },
  data () {
    return {
      form: {
        school_cname: "",
        contact_name: "",
        teacher_name: "",
        faculty_name: "",
        role_name: "",
        baseMtag_name: "",
        baseMtagItem_name: "",
        infoPush_name: "",
        renewal_name: "",
        send_user: "",
        mailname: "",
        email_title: "",
        contact_phone: "",
        email: "",
        renewal_time: [],
        status: null,
        health_type: null,
        date_fr: "",
        date_to: "",
        title: "",
      },
      statusList: [],
      SchoolStatusList: [],
      typeList: []
    };
  },

  mounted () {
    this.info();
  },
  methods: {
    info () {
      if (this.show.statusText) {
        this.SchoolStatusList = this.show.statusText || [];
      }
      if (this.show.typeText) {
        this.typeList = this.show.typeText || [];
      }
    },
    onDate (val) {
      this.form.date_fr = val[0];
      this.form.date_to = val[1];
    },
    outDate () {
      this.form = {
        school_cname: "",
        contact_name: "",
        teacher_name: "",
        faculty_name: "",
        role_name: "",
        baseMtag_name: "",
        baseMtagItem_name: "",
        infoPush_name: "",
        renewal_name: "",
        send_user: "",
        mailname: "",
        email_title: "",
        contact_phone: "",
        email: "",
        renewal_time: [],
        status: null,
        health_type: null,
        date_fr: "",
        date_to: "",
        title: "",
      }
    },
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    handleSubmit () {
      let params = {};
      let { model } = this.$refs.tableForm;
      for (const key in model) {
        if (key == "renewal_time" && isEmpty(model[key][0])) continue;
        if (Array.isArray(model[key]) && isEmpty(model[key])) continue;
        if (model[key] === null || model[key] === "") continue;
        params[key] = model[key];
      }
      this.$emit("submit", params);
    },
    handleReset () {
      this.$refs.tableForm.resetFields();
      this.outDate();
      this.$emit("submit", {});
    }
  }
};
</script>

<style lang="less" scoped>
.hide_input {
  position: absolute;
  top: -500px;
}
.input {
  width: 100%;
}
.item {
  margin-right: 20%;
}
.but {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/myTableFilter.vue